module.exports = __webpack_public_path__ + "media/images/pos-card-7ca9d343c63759a21832f00c103eeb88.png";